import { useEffect, useState } from 'react';
import { collection, onSnapshot, orderBy, query, where, limit } from 'firebase/firestore';
import { db } from '../../../shared/lib/firebase';
import { useAuth } from '../../auth/useAuth';
import { usePermissions } from '../../../shared/hooks/usePermissions';
import type { SupportTicket } from '../lib/types';

/** Manager vê todos; usuário comum vê só os próprios. */
export function useTickets() {
  const { currentUser } = useAuth();
  const { hasPermission } = usePermissions();
  const uid = currentUser?.uid;
  const isManager = hasPermission('MANAGE_SUPPORT_TICKETS');
  const [tickets, setTickets] = useState<SupportTicket[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!uid) return;
    const base = collection(db, 'support_tickets');
    const q = isManager
      ? query(base, orderBy('lastMessageAt', 'desc'), limit(200))
      : query(base, where('createdBy', '==', uid), orderBy('lastMessageAt', 'desc'), limit(200));
    const unsub = onSnapshot(q, (snap) => {
      setTickets(snap.docs.map((d) => ({ id: d.id, ...(d.data() as Omit<SupportTicket, 'id'>) })));
      setLoading(false);
    }, (err) => { console.error('[useTickets]', err); setLoading(false); });
    return unsub;
  }, [uid, isManager]);

  return { tickets, loading, isManager };
}
